import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault(); setErr("");
        if (password.length < 8) return setErr("Password must be at least 8 characters");
        if (password !== confirm) return setErr("Passwords do not match");
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Password reset. Please sign in.");
            navigate("/login");
        } catch (e) { setErr(apiErr(e)); } finally { setLoading(false); }
    };

    return (
        <AuthShell title="Set new password">
            {!token ? (
                <p className="text-sm text-loss">Invalid reset link. <Link to="/forgot-password" className="underline">Request a new one</Link>.</p>
            ) : (
                <form onSubmit={submit} className="space-y-4">
                    <div className="space-y-1.5">
                        <Label>New password</Label>
                        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                            placeholder="••••••••" data-testid="reset-password-input" />
                    </div>
                    <div className="space-y-1.5">
                        <Label>Confirm password</Label>
                        <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
                            placeholder="••••••••" data-testid="reset-confirm-input" />
                    </div>
                    {err && <p className="text-sm text-loss" data-testid="reset-error">{err}</p>}
                    <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit-btn">
                        {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Reset password
                    </Button>
                </form>
            )}
        </AuthShell>
    );
}
